import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import {
  localGetMenu,
  localGetRefreshToken,
  localRemoveMenu,
  localRemoveRefreshToken,
  localRemoveToken,
  localSaveRefreshToken,
  localSaveToken,
} from "../../../utils/localStorage";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  AreaChart,
  Area,
  LineChart,
  Line,
} from "recharts";
import { useNavigate } from "react-router-dom";
import { notifyError, notifyWarning } from "../../../components/notification";
import { api } from "../../../services/api/api.index";
import { API_URL } from "../../../services/api/config";
import { DatePicker } from "antd";
import moment from "moment";
import { TbNetwork } from "react-icons/tb";
const ChartTopLeft = () => {
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [dateData, setDateData] = useState([]);
  const [total, setTotal] = useState([0, 0]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [value, setValue] = useState(null);

  const getData = async () => {
    setLoading(true);
    setData1([]);
    setData2([]);

    try {
      let { data } = await api.get(`${API_URL}api/v1/reports/summary`, {
        from_date: value
          ? value[0].format("YYYY-MM-DD")
          : moment().add(-1, "M").format("YYYY-MM-DD"),
        to_date: value
          ? value[1].format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD"),
      });
      setDataSource(data);
      let fakeData1 = [...data].map((x) => {
        return Number(x.total_client_form_answer?.toFixed(0)).toFixed(0);
      });
      let fakeData2 = [...data].map((x) => {
        return Number(x.total_client_visit_page?.toFixed(0)).toFixed(0);
      });

      let fakeData3 = [...data].map((x) => {
        let myDate = x.date;
        myDate = myDate.split("-");
        let newDate = new Date(
          parseInt(myDate[2]),
          parseInt(myDate[1]) - 1,
          parseInt(myDate[0])
        );
        newDate.setHours(newDate.getHours() + 7);
        console.log(newDate.getTime());
        return newDate.getTime();
      });

      setLoading(false);
      let fakeTotal1 = 0;
      for (let i = 0; i < fakeData1.length; i++) {
        fakeTotal1 = Number(fakeTotal1) + Number(fakeData1[i]);
      }
      let fakeTotal2 = 0;
      for (let i = 0; i < fakeData2.length; i++) {
        fakeTotal2 = Number(fakeTotal2) + Number(fakeData2[i]);
      }
      setLoading(false);
      setTotal([fakeTotal1, fakeTotal2]);
      setData1(fakeData1);
      setData2(fakeData2);
      setDateData(fakeData3);
    } catch (e) {
      if (e.statusCode === 401) {
        try {
          let { data } = await axios({
            method: "POST", //you can set what request you want to be
            url: `${API_URL}api/v1/auth/refresh-token`,
            headers: {
              Authorization: "Bearer " + localGetRefreshToken(),
            },
          });

          localSaveToken(data?.data?.accessToken);
          localSaveRefreshToken(data?.data?.refreshToken);
          getData();
        } catch (e) {
          navigate("/login");
          localRemoveRefreshToken();
          localRemoveToken();
          localRemoveMenu();
        }
      } else if (e.statusCode === 403) {
        navigate("/login");
        localRemoveRefreshToken();
        localRemoveToken();
        localRemoveMenu();
      } else {
        if (e.statusCode < 500) {
          notifyWarning(e.message);
        } else {
          notifyError("Chức năng đang bảo trì vui lòng thử lại sau.");
        }
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    getData();
  }, [value]);

  const disabledDate = (current) => {
    return (
      current &&
      (current < moment().add(-365, "d").endOf("day") ||
        current > moment().endOf("day"))
    );
  };
  const CustomTooltip = ({ active, payload, label }) => {
    const isVisible = active && payload && payload.length;
    console.log("12321",payload)
    return (
      <div
        className="custom-tooltip"
        style={{ visibility: isVisible ? "visible" : "hidden" }}
      >
        {isVisible && (
          <div
            style={{
              background: "#fff",
              padding: "12px",
              borderRadius: "4px",
            }}
          >
            <p className="label" style={{ fontSize: "14px" }}>
              {`${label}`}
            </p>
            <p className="desc" style={{ fontSize: "14px" }}>
              Số lượng khách truy cập: {`${payload[0].value}`}
            </p>
             <p className="desc" style={{ fontSize: "14px" }}>
              Số lượng khách nhập form: {`${payload[1].value}`}
            </p>
          </div>
        )}
      </div>
    );
  };
  return (
    <div style={{ background: "#fff", padding: "8px", borderRadius: "8px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <p
          style={{
            fontSize: "16px",
            display: "flex",
            alignItems: "center",
            marginLeft: "16px",
          }}
        >
          <TbNetwork size={24} />
          &nbsp;Số lượt truy cập
        </p>
        <DatePicker.RangePicker
          style={{ width: "240px" }}
          value={value}
          placeholder={[
            moment().add(-1, "M").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
          ]}
          onChange={(val) => {
            setValue(val);
          }}
          changeOnBlur
        />
      </div>
      <div style={{ width: "100%", height: 350 }}>
        <div
          style={{
            width: "100%",
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          {total[1]} lượt truy cập - {total[0]} lượt nhập form
        </div>
        <ResponsiveContainer>
          <AreaChart
                    width={500}
                    height={400}
                    data={dataSource}
                    margin={{
                      top: 10,
                      right: 30,
                      left: 0,
                      bottom: 0,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis />
                    <Tooltip content={CustomTooltip} />
                    <Area
                      type="monotone"
                      dataKey="total_client_visit_page"
                      stroke="#8884d8"
                      fill="#8884d8"
                      label="Lợi nhuận"
                    />
                    <Area
                      type="monotone"
                      dataKey="total_client_form_answer"
                      stroke="#4442d4"
                      fill="#4442d4"
                      label="Lợi nhuận"
                    />
                  </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ChartTopLeft;
